export const InteriorDesignTemplate = {
    getFormName() {
        return {
            //InteriorDesignTemplate Section - 1

            project_id: 0,
            IDContractAmountTotal:'',
            IDContractAmountComments:'',
            IDContractAmountPerComplete:'',
            IDContractAmountInterior:'',
            IDContractAmountVPC:'',
            AmountUsedTotal:'',
            AmountUsedComments:'',
            AmountUsedPerComplete:'',
            AmountUsedinterior:'',
            AmountUsedVPC:'',
            GpPerTotal:'',
            GpPerComments:'',
            GpPerComplete:'',
            GpPerInterior:'',
            GpPerVPC:'',
            
            //InteriorDesignTemplate Section - 2
            ProjectPreferenceComplete:'N',
            ProjectPreferenceComments:'',
            ProjectPreferenceInterior:'',
            ProjectPreferenceVPC:'',
            RFIComplete:'N',
            RFIComments:'',
            RFIInterior:'',
            RFIVPC:'',
            DrawingsComplete:'N',
            DrawingsComments:'',
            Drawingsinterior:'',
            DrawingsVPC:'',
            SelectionsComplete:'N',
            SelectionsComments:'',
            SelectionsInterior:'',
            SelectionsVPC:'',
            FLoorPlanComplete:'N',
            FLoorPlanComments:'',
            FLoorPlanInterior:'',
            FLoorPlanVPC:'',
            ProjectPreferencePerComplete:'N',
            RFIPerComplete:'',
            DrawingsPerComplete:'',
            SelectionsPerComplete:'',
            FLoorPlanPerComplete:'',
            
            
            //InteriorDesignTemplate Section - 3
            dear:'',
            summaryFrom:'',
            summaryTo:'',
            summaryVPC:'',
            dearVPCComments:'',
            riskSafety:'',

            
            section_4: [
                {
                    selection: 'Plumbing fixture locations in concrete',
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Power in Concrete",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Pools and Hot Tubs",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Hose Bib Location",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Lighting Plan",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Landscape Design",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Irrigation System",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior Doors/Patio Door Schedule",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Window Schedule",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior Flatwork Details",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
            ],

            section_5: [
                {
                    selection: "Outdoor Kitchen Appliances",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Garage Doors",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior Finishes (fencing if applic)",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior paint",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                }
            ],
            
            section_6: [
                {
                    selection: "Plumbing",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Lighting Fixtures",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Interior Finishing Details",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Cabinetry",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Countertops",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Tile/Flooring/Grout",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Appliances",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Mirrors/Glass",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Bathroom Accessories",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Interior Paint",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Interior Door/Hardware",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                }
            ],
            
            section_7: [
                {
                    selection: "Exterior Doors/Windows (if applic.)",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior Lighting/Power Plan",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Exterior Flatwork Details (if applicable)",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                }
            ],
           
            section_8: [
                {
                    selection: "Plumbing Plan",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Lighting/Power Plan",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Bath Hardware/TV/Backing Locations",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Custom Millwork Details",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Custom Closets",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Cabinetry",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Countertop Layouts",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Tile Material & Layout",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Flooring Layout",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Shower Glass and Mirrors",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Interior Finishing Details",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Special Finishes Locations",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                }
            ],

            //InteriorDesignTemplate Section - 9
            section_9: [
                {
                    selection: "Electrical and Plumbing Rough In",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Lock Up/Framing",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Cabinet Measure",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Flooring & Tile Install",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Countertop Template",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
                {
                    selection: "Hardware",
                    completed: 'N',
                    interiorDesignerComments: '',
                    idBidReq: '',
                    pO: '',
                    poOrDDue: '',
                    vPSComments: '',
                },
            ],

            //InteriorDesignTemplate Section - 10
            section_10: [
                {
            genrealProjectCheckListTitle: "Misk 1",
            misc1: "N",
            miscReason: '',
                },
            ],
        }
    },

    section_1_List() {
        return [ "IDContractAmountTotal", "IDContractAmountComments", "IDContractAmountPerComplete", "IDContractAmountInterior", "IDContractAmountVPC", "AmountUsedTotal", "AmountUsedComments", "AmountUsedPerComplete", "AmountUsedinterior", "AmountUsedVPC", "GpPerTotal", "GpPerComments", "GpPerComplete", "GpPerInterior", "GpPerVPC",]
    },
    section_2_List() {
        return [ "ProjectPreferenceComplete", "ProjectPreferenceComments", "ProjectPreferenceInterior", "ProjectPreferenceVPC", "RFIComplete", "RFIComments", "RFIInterior", "RFIVPC", "DrawingsComplete", "DrawingsComments", "Drawingsinterior", "DrawingsVPC", "SelectionsComplete", "SelectionsComments", "SelectionsInterior", "SelectionsVPC", "FLoorPlanComplete", "FLoorPlanComments", "FLoorPlanInterior", "FLoorPlanVPC", "ProjectPreferencePerComplete", "RFIPerComplete", "DrawingsPerComplete", "SelectionsPerComplete", "FLoorPlanPerComplete",]
    },
    section_3_List() {
        return ["dear", "summaryFrom", "summaryTo", "summaryVPC", "dearVPCComments", "riskSafety",]
    },
}